import React, { useEffect, useState } from "react";
import Header from "../Layout/Header";
import About from "./About";
import Footer from "../Layout/Footer";
import { BaseUrl } from "../..";
import Booking from "./Booking";
import Results from "./Results";

function Home() {
  const [responseData, setResponseData] = useState(null);



  const getCurrentDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const yyyy = today.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }





  const API_URL_N = `${BaseUrl}singleluckynumber`;

  const fetchNumber = async () => {
    try {
      const response = await fetch(API_URL_N, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (data.status === "Success") {
        setResponseData(data.data);
      } else {
        setResponseData();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchNumber();

    // Set dynamic SEO meta tags
    document.title = "Madhu Shree Satta Matka | Fast Results, Charts & Tips – Madhushree.in";

    const setMetaTag = (name, content) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    setMetaTag("description", "Get the fastest Satta Matka results, expert tips, and updated charts at Madhu Shree – your trusted source for reliable Matka game info. Visit Madhushree.in for daily updates.");
    setMetaTag("keywords", "Madhu Shree Satta Matka, Satta Matka result, Madhushree Matka chart, Matka tips and tricks, Fast Satta results, Kalyan Matka updates, Madhushree satta guessing, Online Matka play, Matka number prediction, Madhushree Matka today result");

  }, []);

  return (
    <>
      <Header />
      <div className="hero-banner">
        <div className="welcome-messages">
          <h1> Welcome to Madhu Shree Satta Matka </h1>
          <p>🌐 Multilingual Greetings </p>
          <p>🙏 मधु श्री सट्टा मटका में आपका स्वागत है</p>
          <p>🙏 மதூர் ஶ்ரீ சத்தா மட்காவிற்கு வரவேற்கிறோம்</p>
          <p>🙏 মধু শ্রী সত্তা মটকা স্বাগতম</p>
          <p>🙏 మధు శ్రీ సత్తా మట్కాకు స్వాగతం</p>
          <p>🙏 મધુ શ્રી સત્તા મટકામાં આપનું સ્વાગત છે</p>
        </div>
      </div>
      <div className="container">
        <div className="matka-info-box">
          <h2>Madhu Shree Satta Matka Result </h2>
          <p>
            <a href="https //www.madhushree.in" target="_blank">
              www.madhushree.in
            </a>{" "}
            is India’s No.1 Matka Result Website!
          </p>
          <ul>
            <li>Aaj Ka Satta Fix Single Jodi Update</li>
            <li>Best Matka Tips from Experts</li>
            <li>Instant Fast Matka Result</li>
            <li>Morning, Day & Night Results</li>
            <li>App Based Guessing – Trusted by Thousands</li>
          </ul>
        </div>
        <Booking />
        <div className="layout_golden">
          <div className="row">
            <div>
              <h3 className="text-center heading_golden">
                {getCurrentDate()}
              </h3>
              <h3 className="text-center heading_golden">
                LUCKY NUMBER
              </h3>
            </div>
            <div>
              {responseData?.length > 0 ? (
                responseData.map((item, index) => (
                  <div
                    key={index}
                    className="text-center fs-4 number-container"
                  >
                    <span className="me-1 number" style={{ color: '#ff1800' }}>{item.SLN1}</span>
                    <span className="me-1 number" style={{ color: '#ff1800' }}>{item.SLN2}</span>
                    <span className="me-1 number" style={{ color: '#ff1800' }}>{item.SLN3}</span>
                    <span className="me-1 number" style={{ color: '#ff1800' }}>{item.SLN4}</span>
                  </div>
                ))
              ) : (
                <div className="text-center">No data available</div>
              )}
            </div>
          </div>
        </div>
        <Results />
        <About />
        <div class="support-box">
          <p>
            <em>Email for any inquiries Or Support:</em>
          </p>
          <div class="email-button">madhushreeofficia13@gmaiI.com</div>
        </div>
        <div className="refresh-button-wrapper">
          <button
            onClick={() => window.location.reload()}
            className="refresh-button"
          >
            Refresh
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
}
export default Home;
